// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__7ST33","content":"default_content__ZcpVi","column":"default_column__3WpSk"};